<div class="shell-container">

  <div [class.collapsed]="sidebarCollapsed" class="shell-sidenav">
    <app-sidebar [collapsed]="sidebarCollapsed" (toggleSidebar)="toggleSidebar()"></app-sidebar>
  </div>

  <mat-sidenav-container class="shell-content-container">
    <mat-sidenav-content class="shell-content">
      <app-nav-header [sidebarCollapsed]="sidebarCollapsed"></app-nav-header>
      <main class="shell-main">
        <router-outlet></router-outlet>
      </main>
    </mat-sidenav-content>

  </mat-sidenav-container>

</div>